export function not(a, b) {
  return a.filter((value) => b.indexOf(value) === -1);
}

export function intersection(a, b) {
  return a.filter((value) => b.indexOf(value) !== -1);
}

export function union(a, b) {
  return [...a, ...not(b, a)];
}
export const alphabetically = (a, b) => {
  if (a > b) return 1;
  if (b > a) return -1;
  return 0;
};

export const sortStreams = (currentSelected) => (s1, s2) => {
  const s1Chosen = currentSelected.has(s1);
  const s2Chosen = currentSelected.has(s2);

  if (s1Chosen && s2Chosen) {
    return alphabetically();
  } else if (s1Chosen && !s2Chosen) {
    return -1;
  } else if (!s1Chosen && s2Chosen) {
    return 1;
  } else {
    return alphabetically();
  }
};

export const toSourceMap = (fieldMap) => {
  const smaps = Object.values(fieldMap)
    .filter((fm) => fm.isSelected)
    .map((fm) => ({
      name: fm.name,
      selected: fm.selected,
    }));
  const newFieldMaps = {};
  smaps.forEach((fm) => {
    newFieldMaps[fm.name] = fm;
  });
  return newFieldMaps;
};

export const getPrimaryKeys = (catalog) => {
  const result = {};
  catalog &&
    catalog?.streams?.forEach((stream) => {
      if (stream.key_properties) {
        result[stream.stream] = stream.key_properties;
        return;
      }
      try {
        const filteredMetadatas = stream.metadata.filter((metadata) => metadata.metadata.inclusion === 'automatic');
        result[stream.stream] = filteredMetadatas.map((x) => x.breadcrumb.filter((x) => x !== 'properties')).flat();
      } catch (err) {
        console.error(err);
        result[stream.stream] = [];
      }
    });
  return result;
};

export const toFieldMap = (catalog, currentFieldMap, flow = undefined, filter = undefined) => {
  const fieldMap = {};

  const isStreamInCurrent = (stream) => {
    if (!currentFieldMap || !currentFieldMap[stream]) return false;
    if (currentFieldMap[stream].isSelected) return currentFieldMap[stream].isSelected;
    return true;
  };

  const isFieldInCurrent = (stream, field) => {
    if (!currentFieldMap || !currentFieldMap[stream]) return false;
    return currentFieldMap[stream].selected.find((s) => s === field) != undefined;
  };

  if (catalog && catalog.streams)
    catalog.streams.forEach((s) => {
      const name = s.stream;
      if (!fieldMap[s]) {
        const all = (s.schema.properties && Object.keys(s.schema.properties)) || [];
        fieldMap[name] = {
          name,
          all: all,
          selected: [],
          notSelected: [],
          isSelected: isStreamInCurrent(name),
        };
      }

      let wildcardFlag = false;

      if (currentFieldMap && currentFieldMap[name]?.selected.includes("*")) {
        fieldMap[name].selected = ["*"]
        fieldMap[name].notSelected = []
        wildcardFlag = true;
      }

      s.metadata.forEach((m) => {
        if (m.breadcrumb && m.breadcrumb.length == 0) {
          return;
        }

        const field = m.breadcrumb[1];


        const fieldsToFilter = filter && filter.fieldsFilter && filter.fieldsFilter(flow, name, field);
        if (fieldsToFilter?.length > 0 && !fieldsToFilter?.includes(field)) return fieldMap;

        const isSelected =
          isFieldInCurrent(name, field) || (m.metadata['inclusion'] && m.metadata['inclusion'] == 'automatic');

        if (isSelected && !wildcardFlag) {
          if (!fieldMap[name].selected.find((s) => s === field)){
             fieldMap[name].selected.push(field);
             fieldMap[name].notSelected = fieldMap[name].notSelected.filter((x) => x !== field);
            }
        } else {
          if (field) {
            fieldMap[name].notSelected.push(field);
          } else {
            console.warn(`WARN: No breadcrumb for the field..${name}:${field}`, m);
          }
        }
      });
    });

  return fieldMap;
};

export const currentSelection = (fieldMap) => {
  return new Set(
    Object.values(fieldMap)
      .filter((s) => s.isSelected)
      .map((s) => s.name)
  );
};
